import { CheckCircle, Award, Users, Trophy } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const About = () => {
  const { t } = useLanguage();
  
  const achievements = [
    { icon: Award, title: t('about.achievements.elite.title'), desc: t('about.achievements.elite.desc') },
    { icon: Users, title: t('about.achievements.science.title'), desc: t('about.achievements.science.desc') },
    { icon: Trophy, title: t('about.achievements.holistic.title'), desc: t('about.achievements.holistic.desc') },
    { icon: CheckCircle, title: t('about.achievements.results.title'), desc: t('about.achievements.results.desc') }
  ];

  return (
    <section id="about" className="py-20 bg-card/30">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Left Content */}
          <div className="scroll-reveal">
            <h2 className="text-4xl md:text-5xl font-black mb-6">
              {t('about.title')}
            </h2>
            
            <p className="text-lg text-muted-foreground mb-8">
              {t('about.subtitle')}
            </p>
            
            <p className="text-lg text-muted-foreground mb-8">
              {t('about.description')}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {achievements.map((achievement, index) => {
                const Icon = achievement.icon;
                return (
                  <div key={index} className="card-premium text-left p-4">
                    <div className="flex items-start gap-3">
                      <Icon className="h-6 w-6 text-primary mt-1 flex-shrink-0" />
                      <div>
                        <div className="font-bold text-sm mb-1">{achievement.title}</div>
                        <div className="text-xs text-muted-foreground leading-relaxed">{achievement.desc}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Content - Stats & Visual */}
          <div className="scroll-reveal">
            <div className="relative">
              <div className="card-premium p-8 text-center">
                <h3 className="text-2xl font-bold mb-6">{t('about.whyChoose')}</h3>
                
                <div className="space-y-6">
                  <div className="border-l-4 border-primary pl-6 text-left">
                    <h4 className="font-bold text-primary">{t('about.resultsDriven.title')}</h4>
                    <p className="text-sm text-muted-foreground">{t('about.resultsDriven.description')}</p>
                  </div>
                  
                  <div className="border-l-4 border-primary pl-6 text-left">
                    <h4 className="font-bold text-primary">{t('about.personalized.title')}</h4>
                    <p className="text-sm text-muted-foreground">{t('about.personalized.description')}</p>
                  </div>
                  
                  <div className="border-l-4 border-primary pl-6 text-left">
                    <h4 className="font-bold text-primary">{t('about.support.title')}</h4>
                    <p className="text-sm text-muted-foreground">{t('about.support.description')}</p>
                  </div>
                  
                  <div className="border-l-4 border-primary pl-6 text-left">
                    <h4 className="font-bold text-primary">{t('about.proven.title')}</h4>
                    <p className="text-sm text-muted-foreground">{t('about.proven.description')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;